import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/ui/dialogs/Dialog';
import { CheckCircle2Icon } from '@/shared/ui/icons';
import { cn } from '@/shared/utils/cn';
import { LANGUAGES, type LanguageCode } from '@/features/settings/modules/models/useLanguage';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const FeaturesSettingsLanguageDialog = ({ open, onClose }: Props) => {
  const { t, i18n } = useTranslation('settings');
  const current = (i18n.resolvedLanguage ?? i18n.language ?? 'uz').slice(0, 2) as LanguageCode;

  const change = (lang: LanguageCode): void => {
    void i18n.changeLanguage(lang);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} title={t('languageTitle')} size="sm">
      <div role="group" aria-label={t('languageTitle')} className="flex flex-col gap-2">
        {LANGUAGES.map(({ code, native, Flag }) => {
          const active = current === code;
          return (
            <button
              key={code}
              type="button"
              onClick={() => change(code)}
              aria-pressed={active}
              className={cn(
                'flex cursor-pointer items-center justify-between rounded-xl border px-4 py-3 text-sm font-medium transition-colors',
                active
                  ? 'border-brand-200 bg-brand-50 text-brand-700'
                  : 'border-slate-200 bg-white text-ink-soft hover:bg-slate-50',
              )}
            >
              <span className="flex items-center gap-3">
                <Flag className="h-5 w-7 shrink-0 rounded-sm" aria-hidden />
                {native}
              </span>
              {active && <CheckCircle2Icon className="h-5 w-5 text-brand-600" aria-hidden />}
            </button>
          );
        })}
      </div>
    </Dialog>
  );
};
